module.exports = __webpack_public_path__ + "img/05dcd4a.webp";